module.exports = __webpack_public_path__ + "img/photo5.c5005dc6.jpg";